import { z } from 'zod';

import type { TranslationKey } from '@/i18n-key';

import { meetingContextSchema } from '@/pages/ThematicMeetings/utils/meetingRichText';
import { THEMATIC_MEETING_TOPICS } from '@/types/thematic-meetings';

const EMPLOYEE_REQUIRED_MESSAGE: TranslationKey = 'thematicMeetings.validation.employeeRequired';
const TOPIC_REQUIRED_MESSAGE: TranslationKey = 'thematicMeetings.validation.topicRequired';

/** How long the meeting runs is the template's answer, not a question the flow asks: the form
 *  carries no duration, and the meeting is created without one. */
export const newMeetingSchema = z.object({
    employeeId: z.string().min(1, { message: EMPLOYEE_REQUIRED_MESSAGE }),
    // The topic list lives in a single place (`@/types/thematic-meetings`); the schema derives its
    // enum from it so a new topic never has to be declared twice.
    topic: z.enum(THEMATIC_MEETING_TOPICS, { message: TOPIC_REQUIRED_MESSAGE }),
    context: meetingContextSchema.optional(),
});

export type NewMeetingFormData = z.infer<typeof newMeetingSchema>;
